import React, { useState } from 'react';

import { Alert } from '@wds/alert';
import { Box } from '@wds/box';

import PropTypes from 'prop-types';
import { Button } from '@wds/button';
import ajax from '../../../ajax';

const AlertBanner = (props) => {
	const { alert } = props;
	const [show, setShow] = useState(true);

	const colorMap = {
		0: 'warning',
		1: 'error',
		2: 'info',
	};

	const handleContentClick = (e) => {
		const findAnchor = (element) => {
			while (element && (element.tagName !== 'A' && element.tagName !== 'BUTTON')) {
				if (element.tagName === 'SPAN' && element === e.currentTarget) return null;
				element = element.parentElement;
			}
			return element;
		};

		const toCamelCase = (s) => s.replace(/-([a-z])/g, (match, group1) => group1.toUpperCase()).replace(/^([A-Z])/, (match, group1) => group1.toLowerCase());
		const anchor = findAnchor(e.target);
		if (!anchor) return;

		// Collect all data-track-* attributes
		let event = null;
		const trackingData = {};
		Array.from(anchor.attributes).forEach((attr) => {
			if (attr.name.startsWith('data-track-')) {
				const key = toCamelCase(attr.name.replace('data-track-', ''));
				if (key === 'event') {
					event = attr.value;
				} else {
					trackingData[key] = attr.value;
				}
			}
		});
		// eslint-disable-next-line no-undef
		if (event) track(event, trackingData);
	};

	const dismissBanner = () => {
		if (alert.analytic_event) {
			const event = 'notificationDismissed';
			const attributes = { notificationSubject: alert.analytic_event };
			// eslint-disable-next-line no-undef
			track(event, attributes);
		}
		const storageKey = `systemnotification-${alert.id}`;
		localStorage.setItem(storageKey, 'hide');
		setShow(false);
	};

	const editEligibility = () => {
		const url = reverse('applicant-eligibility-edit');
		window.location.href = url;
	};

	const sendEmailVerificationLink = () => {
		ajax.post({ url: reverse('resend-email-verification') });
	};

	let actions = null;
	if (alert.button_text) {
		if (alert.id === 'profile-update') {
			actions = (
				<Button size='sm' onDark onClick={editEligibility} variant='warning'>
					{ alert.button_text }
				</Button>
			);
		} else if (alert.id === 'email-verification') {
			actions = (
				<Button size='sm' onDark onClick={sendEmailVerificationLink} variant='warning'>
					{ alert.button_text }
				</Button>
			);
		} else {
			actions = (<Button size='sm' onDark variant='warning'>{ alert.button_text }</Button>);
		}
	}

	return (
		<Alert
			show={show}
			onClose={dismissBanner}
			showIcon
			dismissible={alert?.dismissible}
			actions={actions}
			color={colorMap[alert?.color]}
			closeButtonLabel='Close Alert'
			data-testid={alert?.title}
		>
			<Box element='span' display='flex' justifyContent='start' gap={1}>
				<Box
					element='span'
					onClick={handleContentClick}
					dangerouslySetInnerHTML={{ __html: alert.content }}
				/>
			</Box>
		</Alert>
	);
};

AlertBanner.propTypes = {
	alert: PropTypes.shape({
		title: PropTypes.string,
		content: PropTypes.string,
		button_text: PropTypes.string,
		color: PropTypes.number,
		dismissible: PropTypes.bool,
	}),
};
AlertBanner.defaultProps = {
	alert: {
		title: '',
		content: '',
		button_text: '',
		color: 0,
		dismissible: false,
	},
};

export default AlertBanner;
